import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import axios from "axios";
import "./Style.css";

const AddStaffForm = ({ member, onSubmit, onCancel }) => {

  const userDetails = useMemo(() => {
    const storedDetails = sessionStorage.getItem("userDetails");
    return storedDetails ? JSON.parse(storedDetails) : {};
  }, []);

  const filteredRoles = useMemo(() => {
    const storedRoles = sessionStorage.getItem("filteredRoles");
    const roles = storedRoles ? JSON.parse(storedRoles) : [];

    // Filter roles that are not "Patient" and have the "Create" permission
    return roles
      .filter((role) => role.roleName === "Admin")
      .filter((role) => {
        const permissions = userDetails?.role?.permissions || [];
        const resourceEntry = permissions.find((entry) => entry.resource === role.roleName);
        return resourceEntry ? resourceEntry.actions.includes("Create") : false;
      });
  }, [userDetails]);


  const rolesOptions = useMemo(() => {
    return filteredRoles.map((role) => ({
      value: role.roleId, // Assuming role._id is the unique identifier
      label: role.roleName,
    }));
  }, [filteredRoles]);

  const defaultRole = useMemo(() => {
    if (member) {
      return rolesOptions.find((role) => role.value === member.roleId) || null;
    }
    return null;
  }, [member, rolesOptions]);

  console.log("member data", member)
  const [formData, setFormData] = useState({
    firstName: member?.firstName || "",
    lastName: member?.lastName || "",
    address: member?.address || "",
    countryCode: member?.countryCode || "",
    phoneNumber: member?.phoneNumber || "",
    dateOfBirth: member?.dateOfBirth || "",
    gender: member?.gender || "",
    email: member?.email || "",
    roleId: member?.roleId || "",
    profileImage: null,
    _id: member?._id || ""
  });


  const [roles, setRoles] = useState([...filteredRoles]);
  const [errors, setErrors] = useState({});
  const countryCodeOptions = [
    { value: "+1", label: "US (+1)" },
    { value: "+91", label: "India (+91)" },
    { value: "+44", label: "UK (+44)" },
    { value: "+61", label: "Australia (+61)" },
    { value: "+81", label: "Japan (+81)" },
  ];


  const hospitalId = userDetails.hospitalId;
  
  const validateField = (name, value) => {
    const fieldErrors = {};

    if (!value) {
      fieldErrors[name] = `${name.replace(/([A-Z])/g, " $1")} is required.`;
    } else if (name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      fieldErrors[name] = "Please enter a valid email address.";
    } else if (name === "phoneNumber" && !/^\d{10}$/.test(value)) {
      fieldErrors[name] = "Phone number must be 10 digits.";
    } else if (name === "profileImage" && value) {
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!allowedTypes.includes(value.type)) {
        fieldErrors[name] = "Only JPG and PNG images are allowed.";
      }
    }
    else if (name === "dateOfBirth" && !value) {
      fieldErrors[name] = "Date of Birth is required.";
    } else if (name === "gender" && !value) {
      fieldErrors[name] = "Gender is required.";
    }

    return fieldErrors;
  };

  const validateAll = () => {
    const newErrors = {};
    for (const [key, value] of Object.entries(formData)) {
      const fieldErrors = validateField(key, value);
      Object.assign(newErrors, fieldErrors);
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("Field Changed:", name, value);
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      validateField(name, value);
    }
  };
  const handleCountryCodeChange = (selectedOption) => {
    setFormData({ ...formData, countryCode: selectedOption?.value || "" });
    if (errors["countryCode"]) {
      validateField("countryCode", selectedOption?.value || "");
    }
  };
  const handleRoleChange = (selectedOption) => {
    console.log("selected role :", selectedOption);
    setFormData({ ...formData, roleId: selectedOption?.value || "" });
    if (errors["roleId"]) {
      validateField("roleId", selectedOption?.value || "");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("File Selected:", file);
    if (file) {
      validateField("profileImage", file);
    }
    setFormData({ ...formData, profileImage: file });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data Before Validation:", formData);

    if (true) {
      console.log("Validation Passed!");

      const formDataToSubmit = new FormData();

      // Append data to FormData
      Object.keys(formData).forEach((key) => {
        if (key === "profileImage" && formData.profileImage instanceof File) {
          formDataToSubmit.append("image", formData.profileImage);
        } else if (formData[key] !== undefined && formData[key] !== null) {
          formDataToSubmit.append(key, formData[key]);
        }
      });
      formDataToSubmit.append("hospitalId", userDetails.hospitalId);

      // Debugging FormData
      console.log("FormData Contents:");
      for (let [key, value] of formDataToSubmit.entries()) {
        console.log(key, value);
      }

      // Find resource name
      const resourceName = rolesOptions.find((role) => role.value === formData.roleId)?.label;

      console.log("resouces: ", rolesOptions, "")
      if (!resourceName) {
        console.error("Role label not found for the given roleId.");
        return;
      }
      await onSubmit(formDataToSubmit);
    } else {
      console.log("Form Validation Failed:", errors);
    }
  };

  return (
    <div className="form-container">
      <p className="back-link" onClick={onCancel}>
        Back
      </p>
      <form className="registration-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Role</label>
          <Select
            options={rolesOptions}
            onChange={handleRoleChange}
            defaultValue={defaultRole} // Set default value when editing
            placeholder="Select a role"
            isClearable
          />
          <small className="help-text">
            Please select a role from the dropdown that matches the
            responsibilities of the staff you are adding. This is required to
            assign the appropriate permissions and duties.
          </small>
          {errors.roleId && <p className="error-text">{errors.roleId}</p>}
        </div>

        <div className="form-group">
          <label>First Name</label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="Enter first name"
          />
          <small className="help-text">
            Enter the first name of the staff member. This will appear in all
            official communications and records.
          </small>
          {errors.firstName && <p className="error-text">{errors.firstName}</p>}
        </div>

        <div className="form-group">
          <label>Last Name</label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Enter last name"
          />
          <small className="help-text">
            Enter the last name of the staff member. This is important for
            identification purposes.
          </small>
          {errors.lastName && <p className="error-text">{errors.lastName}</p>}
        </div>

        <div className="form-group">
          <label>Gender</label>
          <select name="gender" value={formData.gender} onChange={handleChange}>
            <option value="" disabled>
              Select gender
            </option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          <small className="help-text">
            Select the gender of the staff member.
          </small>
          {errors.gender && <p className="error-text">{errors.gender}</p>}
        </div>

        <div className="form-group">
          <label>Address</label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Enter full address"
            rows="3"
          />
          <small className="help-text">
            Provide the complete address of the staff member, including street,
            city, state, and postal code. This information is necessary for
            official records and correspondence.
          </small>
          {errors.address && <p className="error-text">{errors.address}</p>}
        </div>

        <div className="form-group">
          <label>Date of Birth</label>
          <input
            type="date"
            name="dateOfBirth"
            value={formData.dateOfBirth}
            onChange={handleChange}
            placeholder="Select date of birth"
          />
          <small className="help-text">
            Please provide the date of birth of the staff member for record
            purposes.
          </small>
          {errors.dateOfBirth && (
            <p className="error-text">{errors.dateOfBirth}</p>
          )}
        </div>

        <div className="form-group">
          <label>Phone Number</label>
          <div style={{ display: "flex", gap: "10px" }}>
            <Select
              options={countryCodeOptions}
              defaultValue={countryCodeOptions.find((option) => option.value === member?.countryCode)}
              onChange={handleCountryCodeChange}
              isClearable
              className="country-code-dropdown"
            />
            <input
              type="text"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              placeholder="Enter phone number"
              style={{ flex: 1 }}
            />
          </div>
          <small className="help-text">
            Enter a valid phone number where the staff member can be reached.
            Include the country code if applicable.
          </small>
          {errors.phoneNumber && (
            <p className="error-text">{errors.phoneNumber}</p>
          )}
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter email"
          />
          <small className="help-text">
            Provide a valid email address for the staff member. This will be
            used for login and official communications.
          </small>
          {errors.email && <p className="error-text">{errors.email}</p>}
        </div>

        <div className="form-group">
          <label>Profile Image</label>
          <input type="file" name="profileImage" onChange={handleFileChange} />
          <small className="help-text">
            Upload a clear and recent profile image of the staff member. This
            helps in easy identification within the system.
          </small>
        </div>

        <button type="submit" className="submit-button">
          {member? "Edit Admin": "Add Admin"}
        </button>
      </form>
    </div>
  );
};

export default AddStaffForm;
